import { Body, Heading } from '@assembly-js/design-system';

import { BillingDraftItems } from 'src/features/assistant/action-item/BillingDraftLineItems';
import { BillingDraftSubtotal } from 'src/features/assistant/action-item/BillingDraftSubtotal';
import {
  WidgetContainer,
  WidgetContent,
  WidgetHeader,
} from 'src/features/assistant/action-item/Widget';
import { LineItem } from 'src/services/api/invoicesApi';
import { StripePaymentMethod } from 'src/types/payment';
import { CTA } from 'src/types/stream-chat';
import { formatBillingInterval } from 'src/utils/SubscriptionUtils';

export type InvoiceDraftDetailTypes = {
  lineItems: LineItem[];
  interval?: string;
  currency: string;
  taxPercentage: string;
  tax: string;
  fees: string;
  ignoreFees: boolean;
  feeLabel: string;
  collectionMethod: string;
  totalAmount: string;
  subTotal: string;
  taxAmount: number;
  fee: number;
};
interface Props {
  cta: CTA;
  onCTAClick: (cta: CTA) => void;
  widgetName: string;
  isSubscription?: boolean;
  billingDetails: InvoiceDraftDetailTypes;
  avatarMap: Record<string, string>;
  source?: StripePaymentMethod | string | null | undefined;
  buttonName: string;
}
export default function BillingDraftWidget({
  cta,
  onCTAClick,
  widgetName,
  avatarMap,
  billingDetails,
  source,
  buttonName,
}: Props) {
  return (
    <WidgetContainer>
      <WidgetHeader
        widgetName={widgetName}
        buttonName={buttonName}
        buttonIcon="Plus"
        onClick={() => onCTAClick(cta)}
      />
      <WidgetContent>
        <div className="flex justify-center pt-3 pb-5">
          <div className="flex gap-2 items-end">
            <Heading size="xl" className="leading-[28px]">
              {billingDetails.totalAmount}
            </Heading>
            {billingDetails.interval && (
              <Body size="sm" className="text-gray-small leading-[21px]">
                {formatBillingInterval(billingDetails.interval)}
              </Body>
            )}
          </div>
        </div>
        <BillingDraftItems
          billingDetails={billingDetails}
          avatarMap={avatarMap}
        />
        <BillingDraftSubtotal billingDetails={billingDetails} source={source} />
      </WidgetContent>
    </WidgetContainer>
  );
}
